<!--
 * @Description: xuzhongqi
 * @Version: 1.0
 * @Autor: xuzhongqi
 * @Date: 2022-01-08
 * @LastEditors: Jerry
 * @LastEditTime: 2022-02-17 15:41:26
-->
<template>
  <div>
    <el-row class="item-box">
      <el-col :span="24">
        <div class="item-row-logo">
          <van-image :src="item.Logo" fit="cover" class="reduction">
            <template #error>加载失败</template>
          </van-image>
          <!-- 左上角固定角标 -->
          <div class="item-logo-fixed">
            <img
              src="../../../assets/fixed1.png"
              fit="cover"
              class="reduction-fiexd"
            >
          </div>
          <!-- 右上角固定角标 -->
          <div class="item-logo-fixed-right">
            <img
              src="../../../assets/fixed2.png"
              fit="cover"
              class="reduction-fiexd-right"
            >
          </div>
          <!-- 图片下方固定规则 -->
          <div class="item-rule-fixed item-rule-fixed-bg1">{{ item.Rule }}</div>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="item-row">
          <label class="item-row-label">
            <img
              src="../../../assets/new.png"
              fit="cover"
              class="reduction"
            >
            {{ item.SkuName }}
          </label>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="item-row">
          <span class="item-row-introduce">规格：{{ item.Specifications }}/{{ item.Unit }}</span>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="item-row">
          <span class="item-row-introduce">效期：{{ item.Validity }}</span>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="item-row">
          <nav class="item-price-active">
            <span>
              <img
                src="../../../assets/reduction.png"
                fit="cover"
                class="reduction"
              >
            </span>
            <span class="item-price-catching">¥{{ item.PriceLimit }}</span>
            <span class="item-price-low">¥{{ item.Price }}</span>
          </nav>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="item-row">
          <nav class="item-price-detailed">
            <span class="item-price-catching">最低零售¥{{ item.RetailPrice }}</span>
            <span class="item-price-low">毛利率{{ item.GrossMargin }}%</span>
          </nav>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="item-row">
          <nav class="item-price-mark">
            <span class="">{{ item.Type === 6 ? '满减' : '满赠' }}</span>
            <span v-if="item.MedicalType === 0" class="">医保</span>
            <span v-else-if="item.MedicalType === 1" class="">甲类</span>
            <span v-else-if="item.MedicalType === 2" class="">乙类</span>
            <span v-else-if="item.MedicalType === 3" class="">医保</span>
            <span class="">{{ item.CountryCode }}</span>
          </nav>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    // 监听父组件传递的展示值
    defaultData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      // 模糊查询关键字
      Keyword: '',
      // 组件展示默认值对象
      item: {}
    }
  },
  computed: {},
  watch: {
    defaultData: {
      handler(newVal) {
        // 覆盖本地行数据对象
        this.item = newVal
      },
      deep: true, // true 深度监听
      immediate: true // 第一次绑定是否执行
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
@import url("~@/styles/activityView.less");
</style>
